import { nanoid } from "nanoid";

export function createFilledArray(length: number): string[] {
  return Array.from({ length }, () => nanoid());
}
